export default __webpack_public_path__ + "static/media/Glucose disabled.c97a196f.svg";